import { useCashFundActions } from "../actions/cashFundActions"
import { useCashFundBuilders } from "../builders/cashFundBuilders"
import { useCashFundLoaders } from "../loaders/cashFundLoaders"

export const useCashFundService = () => {
    const { buildCashFund } = useCashFundBuilders()

    const cashFundLoaders = useCashFundLoaders()

    const { saveCashFund } = useCashFundActions()

    const archiveCashFund = async (cashFundId: string) => {
        const { loadCashFund } = cashFundLoaders()
        const cashFund = await loadCashFund(cashFundId, true)
        const archivedCashFund = buildCashFund({
            ...cashFund,
            archived: true
        })
        return saveCashFund(archivedCashFund)
    }

    return {
        archiveCashFund
    }
}
